import { Component, Inject, Injector, Input, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';

import { BehaviorSubject, Subscription } from 'rxjs';

import { ActionService, AuthService, FileService, ISitemap, ResolverLoadingService, SITEMAP } from 'pbc.angular';

import { IDeleteFondRequest, IDeleteFondResponse, IFond, IPostFondRequest, IPostFondResponse } from 'fa-kt.types';
import { DeleteFondCommandService, PostFondCommandService } from '../../commands';

@Component({
  selector: 'fa-kt-fonds',
  templateUrl: './fonds.component.html',
  styleUrls: ['./fonds.component.css'],
})
export class FondsComponent implements OnInit, OnDestroy {
  private readonly subscriptions: Subscription[] = [];

  public readonly $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public readonly $postFond: BehaviorSubject<IPostFondRequest | null> = new BehaviorSubject<IPostFondRequest | null>(null);
  public readonly $deleteFond: BehaviorSubject<IDeleteFondRequest | null> = new BehaviorSubject<IDeleteFondRequest | null>(null);

  @Input() disabled = false;
  @Input() kunde: string = '';
  @Input() fonds: any[] = [];

  get modalRef() {
    return this.injector.get(NzModalRef);
  }

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public route: ActivatedRoute,
    private router: Router,
    private injector: Injector,
    private viewContainerRef: ViewContainerRef,
    private modal: NzModalService,
    private message: NzMessageService,
    private actions: ActionService,
    private loading: ResolverLoadingService,
    public auth: AuthService,
    public files: FileService,
    public postFond: PostFondCommandService,
    public deleteFond: DeleteFondCommandService,
  ) {}

  async ngOnInit() {
    this.subscriptions.push(
      ...[
        this.route.queryParams.subscribe(async (params: Params) => {}),
        /* << subscriptions    */
        /*    subscriptions >> */
      ],
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  async finishedPostFond(response?: IPostFondResponse) {
    /* << after post-fond    */
    this.openFond(null);
    /*    after post-fond >> */
  }

  async finishedDeleteFond(response?: IDeleteFondResponse) {
    /* << after delete-fond    */
    this.openFond(null);
    /*    after delete-fond >> */
  }

  /* << methods    */
  public openFond(fond: IFond | null | any) {
    if (!fond) {
      this.$postFond.next(null);
      this.$deleteFond.next(null);
      return;
    }
    if (!fond.id) {
      fond.aktiv = true;
      fond.kunde = this.kunde;
    }
    this.$postFond.next({ fond });
    if (fond && fond.id) {
      this.$deleteFond.next({ fond: fond.id });
    } else {
      this.$deleteFond.next(null);
    }
  }
  /*    methods >> */

  public async submitPostFond(request?: IPostFondRequest) {
    this.$loading.next(true);
    const payload = request ? request : this.$postFond.getValue();
    if (payload) {
      try {
        const response = await this.postFond.request(payload);
        await this.finishedPostFond(response);
      } catch (error: any) {
        this.message.error('Oops, etwas ist schief gelaufen' + (error && error.message ? ': ' + error.message : ''));
        console.error(error);
      }
    }
    this.$loading.next(false);
  }

  public async submitDeleteFond(request?: IDeleteFondRequest) {
    this.$loading.next(true);
    const payload = request ? request : this.$deleteFond.getValue();
    if (payload) {
      try {
        const response = await this.deleteFond.request(payload);
        await this.finishedDeleteFond(response);
      } catch (error: any) {
        this.message.error('Oops, etwas ist schief gelaufen' + (error && error.message ? ': ' + error.message : ''));
        console.error(error);
      }
    }
    this.$loading.next(false);
  }
}
